module.exports = __webpack_public_path__ + "b7c10b794685749044a7c1add21ea7ab.svg";